module.exports = __webpack_public_path__ + "media/images/top/icon/blue/ico_call-ea84a99472d108f805e392cfcfb01e48.svg";